import {emailKeyName} from "./emailKeyName"

export const emailIndexName = `${emailKeyName}-index`
